import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { createAbsoluteUrl } from "utils/constants";
import { useGlobalSlice } from "app/slice";
import { selectUser } from "app/slice/selectors";

interface SidebarItem {
  to: string;
  label: string;
  target?: string;
}

const getSidebarItems = (user: any): SidebarItem[] => {
  const baseItems = [
    { to: "/my-account/dashboard", label: "My Dashboard" },
    { to: "/my-account/payment-history", label: "Payment History" },
    { to: "/my-account/manage-profile", label: "Manage Profile" },
    { to: "/my-account/manage-cards", label: "Manage Cards" },
    { to: "/my-account/change-password", label: "Change Password" },
    { to: "/my-account/sim-service", label: "SIM Service" },
    // { to: "/support-tickets", label: "Support" },
    {
      to: createAbsoluteUrl("/support-tickets"),
      label: "Support",
      target: "_self",
    },
  ];

  // Only add Sign Out if user is logged in
  if (user) {
    baseItems.push({ to: "/", label: "Sign Out" });
  }

  return baseItems;
};

export const MyAccountSidebar = () => {
  const user = useSelector(selectUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { actions } = useGlobalSlice();

  const sidebarItems = getSidebarItems(user);

  return (
    <div className="hidden lg:block flex-shrink-0 px-4 sm:px-5 md:px-6 lg:pr-0 xl:pl-7 2xl:pl-[1.875rem]">
      <div className="w-full lg:w-48 xl:w-[14.9325rem] pt-2.5 sm:pt-3 md:pt-4 lg:pt-[1.625rem]">
        <div className="relative flex flex-row lg:flex-col lg:max-h-[calc(100vh-15.5rem)] pb-2 lg:pb-0 border-b lg:border-b-0 lg:border-r border-[#E9EAEB] overflow-x-auto lg:overflow-y-auto [&::-webkit-scrollbar]:hidden">
          <nav className="flex lg:flex-col space-x-1 sm:space-x-2 lg:space-x-0 lg:space-y-2 min-w-max lg:min-w-48 xl:min-w-[14.9325rem]">
            {sidebarItems.map((item) =>
              item.label === "Sign Out" ? (
                <div
                  key={item.to}
                  onClick={() => {
                    dispatch(
                      actions.setUser({
                        user: null,
                        rememberDevice: false,
                      })
                    );
                    // navigate("/");
                    window.location.href = createAbsoluteUrl();
                  }}
                  className="flex items-center hover:bg-[#FE4D0112] lg:w-[10.88rem] xl:w-[13.8125rem] h-8 sm:h-9 px-3 py-1.5 sm:py-2 rounded-md hover:text-[#FE4D01] text-[0.825rem] sm:text-sm font-medium hover:font-semibold leading-4 sm:leading-5 cursor-pointer"
                >
                  <h5>{item.label}</h5>
                </div>
              ) : item.target ? (
                <a
                  key={item.to}
                  href={item.to}
                  target={item.target || "_blank"}
                  rel="noopener noreferrer"
                  className="flex items-center lg:w-[10.88rem] xl:w-[13.8125rem] h-8 sm:h-9 px-3 py-1.5 sm:py-2 rounded-md whitespace-nowrap text-[0.825rem] sm:text-sm leading-4 sm:leading-5 transition-colors hover:bg-[#F2F2F2] text-black font-medium"
                >
                  <h5>{item.label}</h5>
                </a>
              ) : (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={({ isActive }) =>
                    `flex items-center lg:w-[10.88rem] xl:w-[13.8125rem] h-8 sm:h-9 px-3 py-1.5 sm:py-2 rounded-md whitespace-nowrap text-[0.825rem] sm:text-sm leading-4 sm:leading-5 transition-colors ${
                      isActive
                        ? "bg-[#FFF7F5] hover:bg-[#FE4D0112] text-[#FE4D01] font-semibold"
                        : "hover:bg-[#F2F2F2] text-black font-medium"
                    }`
                  }
                >
                  <h5>{item.label}</h5>
                </NavLink>
              )
            )}
          </nav>
        </div>
      </div>
    </div>
  );
};
